<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        {{ title }}
      </h1>
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'dashboard' }">
            <i class="fa fa-dashboard"></i> Home
          </router-link>
        </li>
        <li>
          <router-link :to="{name: 'merchant-index'}">
            Merchant
          </router-link>
        </li>
        <li class="active">
          <span v-if="isCreate">Create</span>
          <span v-else>Edit</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Contact Detail Company</h3>
            </div>
            <form id="merchant-form" class="form-horizontal" @submit.prevent="submit">
              <div class="box-body" style="overflow: unset;">
                <div v-if="error" class="alert alert-danger">
                  <a class="close"
                    @click="error = false">
                    &times;
                  </a>
                  {{ error }}
                </div>

                <div class="form-group">
                  <label for="name"
                    class="col-sm-2 control-label">
                    Agent Name <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      placeholder="Name"
                      v-model="merchant.name">
                  </div>
                </div>

                <div class="form-group">
                  <label for="Address"
                    class="col-sm-2 control-label">
                    Address <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="address"
                      placeholder="Address"
                      v-model="merchant.address">
                  </div>
                </div>

                <div class="form-group">
                  <label for="City"
                    class="col-sm-2 control-label">
                    City <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="city"
                      placeholder="City"
                      v-model="merchant.city">
                  </div>
                </div>

                <div class="form-group">
                  <label for="Province"
                    class="col-sm-2 control-label">
                    Province <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="province"
                      placeholder="Province"
                      v-model="merchant.province">
                  </div>
                </div>

                <div class="form-group">
                  <label for="Country"
                    class="col-sm-2 control-label">
                    Country <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="country"
                      placeholder="Country"
                      v-model="merchant.country">
                  </div>
                </div>

                <div class="form-group">
                  <label for="zip_code"
                    class="col-sm-2 control-label">
                    ZIP Code <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="zip_code"
                      placeholder="Zip Code"
                      v-model="merchant.zip_code">
                  </div>
                </div>

                <div class="form-group">
                  <label for="phone"
                    class="col-sm-2 control-label">
                    Phone Number <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="number"
                      class="form-control"
                      id="phone"
                      placeholder="Phone"
                      v-model="merchant.phone">
                  </div>
                </div>

                <div class="form-group">
                  <label for="email"
                    class="col-sm-2 control-label">
                    Email <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="email"
                      placeholder="E-mail"
                      v-model="merchant.email">
                  </div>
                </div>

                <div class="box-header with-border margin-header">
                  <h3 class="box-title">Contact Detail PIC</h3>
                </div>

                <div class="form-group">
                  <label for="pic_name"
                    class="col-sm-2 control-label">
                    PIC Name <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="pic_name"
                      placeholder="PIC Name"
                      v-model="merchant.pic_name">
                  </div>
                </div>

                <div class="form-group">
                  <label for="pic_phone"
                    class="col-sm-2 control-label">
                    Phone Number <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="number"
                      class="form-control"
                      id="pic_phone"
                      placeholder="Phone"
                      v-model="merchant.pic_phone">
                  </div>
                </div>

                <div class="form-group">
                  <label for="pic_email"
                    class="col-sm-2 control-label">
                    Email <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="pic_email"
                      placeholder="E-mail"
                      v-model="merchant.pic_email">
                  </div>
                </div>

                <div class="box-header with-border line-height">
                  <h3 class="box-title">Bank Account</h3>
                  <a class="btn btn-success pull-right"
                    @click.prevent="showAddBank()">
                    Add New
                  </a>
                </div>

                <transition name="slideDown">
                  <modal :title="isEditBank ? 'Edit Bank Account' : 'Add Bank Account'"
                    v-if="show.bank">
                    <form id="bank-form" class="form-horizontal">
                      <div class="box-body" style="overflow: unset;">
                        <div class="form-group">
                          <label for="Currency"
                            class="col-sm-2 control-label">
                            Currency <span class="req">*</span>
                          </label>

                          <div class="col-sm-10">
                            <v-select
                              placeholder="Select Currency"
                              id="currency"
                              :options="list.currency"
                              v-model="bank.currency">
                            </v-select>
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="swift_code"
                            class="col-sm-2 control-label">
                            Swift Code
                          </label>

                          <div class="col-sm-10">
                            <input
                              type="text"
                              class="form-control"
                              id="swift_code"
                              placeholder="Swift Code"
                              v-model="bank.swift_code">
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="bank_name"
                            class="col-sm-2 control-label">
                            Bank Name <span class="req">*</span>
                          </label>

                          <div class="col-sm-10">
                            <input
                              type="text"
                              class="form-control"
                              id="bank_name"
                              placeholder="Bank Name"
                              v-model="bank.name">
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="bank_branch"
                            class="col-sm-2 control-label">
                            Bank Branch
                          </label>

                          <div class="col-sm-10">
                            <input
                              type="text"
                              class="form-control"
                              id="bank_branch"
                              placeholder="Bank Branch"
                              v-model="bank.branch">
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="account_number"
                            class="col-sm-2 control-label">
                            Account Number <span class="req">*</span>
                          </label>

                          <div class="col-sm-10">
                            <input
                              type="number"
                              class="form-control"
                              id="account_number"
                              placeholder="Account Number"
                              v-model="bank.account_number">
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="account_owner"
                            class="col-sm-2 control-label">
                            Account Owner <span class="req">*</span>
                          </label>

                          <div class="col-sm-10">
                            <input
                              type="text"
                              class="form-control"
                              id="account_owner"
                              placeholder="Account Owner"
                              v-model="bank.account_owner">
                          </div>
                        </div>
                      </div>

                      <div class="box-footer">
                        <button v-if="isEditBank" type="submit" class="btn btn-info pull-right" @click="editBank(editIdx)">Edit Bank</button>
                        <button v-else type="submit" class="btn btn-info pull-right" @click.prevent="addBank()">Add Bank</button>
                        <a class="btn btn-default" @click.prevent="()=>{show.bank = false;}">Cancel</a>
                      </div>
                    </form>
                  </modal>
                </transition>

                <table id="table" class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th style="min-width: 3rem;">No</th>
                      <th style="min-width: 8rem;">Bank Name</th>
                      <th style="min-width: 8rem;">Bank Branch</th>
                      <th>Account Owner</th>
                      <th>Account Number</th>
                      <th>Currency</th>
                      <th style="min-width: 10rem;">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="merchant.banks.length < 1">
                    <tr>
                      <td colspan="7">
                        No bank added
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr v-for="bank_acc,index in merchant.banks" :key="index">
                      <td>{{ index+1 }}</td>
                      <td>{{ bank_acc.name }}</td>
                      <td>{{ bank_acc.branch }}</td>
                      <td>{{ bank_acc.account_owner }}</td>
                      <td>{{ bank_acc.account_number }}</td>
                      <td>{{ bank_acc.currency }}</td>
                      <td>
                        <a class="btn btn-primary btn-xs"
                          @click.prevent="showEditBank(index)">
                          Edit
                        </a>
                        <a class="btn btn-danger btn-xs"
                          @click.prevent="removeBank(index)">
                          Delete
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="box-footer">
                <button type="submit" class="btn btn-info pull-right" v-if="isCreate">Create</button>
                <button type="submit" class="btn btn-info pull-right" v-else>Update</button>
                <a class="btn btn-default" @click.prevent="cancel">Cancel</a>
              </div>

            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Common from '@/mixins/Common';
import bus from '@/utils/bus';
import Modal from '@/components/modules/common/Modal';

export default {
  name: 'MerchantForm',

  mixins: [Common],

  data() {
    return {
      title: 'Add New Merchant',

      merchant: {
        id: null,
        name: null,
        address: null,
        city: null,
        province: null,
        country: null,
        zip_code: null,
        phone: null,
        email: null,
        pic_name: null,
        pic_phone: null,
        pic_email: null,
        banks: [],
      },
      bank: {
        currency: 'IDR',
        swift_code: null,
        name: null,
        branch: null,
        account_number: null,
        account_owner: null,
      },
      list: {
        currency: ['IDR', 'USD', 'EUR', 'SGD'],
      },
      show: {
        bank: false,
      },
      isEditBank: false,
      editIdx: null,
      error: null,
    };
  },

  props: {
    isCreate: {
      type: Boolean,
      required: false,
    },
  },

  components: {
    Modal,
  },

  methods: {
    async fetch() {
      this.axios.get(`/merchants/${this.$route.params.id}`)
        .then((response) => {
          const { data } = response.data;
          this.setFormValue(data);
        })
        .catch((error) => {
          if (error.response) {
            this.errors = error.response.data.errors;
          }
        });
    },

    setBanksValue(data) {
      const banks = [];

      if (data.length < 1) return banks;

      data.forEach((bank) => {
        banks.push({
          id: bank.id || null,
          currency: bank.currency || null,
          swift_code: bank.swift_code || null,
          name: bank.bank_name || null,
          branch: bank.bank_branch || null,
          account_number: bank.account_number || null,
          account_owner: bank.account_owner || null,
        });
      });

      return banks;
    },

    setFormValue(data) {
      this.merchant.id = data.id;
      this.merchant.name = data.name || null;
      this.merchant.address = data.address || null;
      this.merchant.city = data.city || null;
      this.merchant.province = data.province || null;
      this.merchant.country = data.country || null;
      this.merchant.country_en = data.country_en || null;
      this.merchant.zip_code = data.zip_code || null;
      this.merchant.phone = data.phone || null;
      this.merchant.email = data.email || null;
      this.merchant.pic_name = data.pic || null;
      this.merchant.pic_phone = data.contact_person || null;
      this.merchant.pic_email = data.pic_email || null;
      this.merchant.banks = this.setBanksValue(data.banks);
    },

    showAddBank() {
      this.isEditBank = false;
      this.setBankFieldEmpty();
      this.showModalBank('bank');
    },

    showEditBank(idx) {
      this.isEditBank = true;
      this.setBankField(idx);
      this.editIdx = idx;
      this.showModalBank('bank');
    },

    showModalBank(modal) {
      if (!this.isEditBank) {
        this.setBankFieldEmpty();
      }
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      bus.$off('close-modal');
      document.body.classList.add('locked');
    },

    addBank() {
      if (!this.validateAddBank()) return;
      this.merchant.banks.push({
        currency: this.bank.currency,
        swift_code: this.bank.swift_code,
        name: this.bank.name,
        branch: this.bank.branch,
        account_number: this.bank.account_number,
        account_owner: this.bank.account_owner,
      });
      this.show.bank = false;
    },

    editBank(idx) {
      if (!this.validateAddBank()) return;
      this.merchant.banks[idx].currency = this.bank.currency;
      this.merchant.banks[idx].swift_code = this.bank.swift_code;
      this.merchant.banks[idx].name = this.bank.name;
      this.merchant.banks[idx].branch = this.bank.branch;
      this.merchant.banks[idx].account_number = this.bank.account_number;
      this.merchant.banks[idx].account_owner = this.bank.account_owner;
      this.show.bank = false;
    },

    removeBank(idx) {
      this.merchant.banks.splice(idx, 1);
    },

    setBankField(idx) {
      this.bank.currency = this.merchant.banks[idx].currency;
      this.bank.swift_code = this.merchant.banks[idx].swift_code;
      this.bank.name = this.merchant.banks[idx].name;
      this.bank.branch = this.merchant.banks[idx].branch;
      this.bank.account_number = this.merchant.banks[idx].account_number;
      this.bank.account_owner = this.merchant.banks[idx].account_owner;
    },

    setBankFieldEmpty() {
      this.bank.currency = 'IDR';
      this.bank.swift_code = null;
      this.bank.name = null;
      this.bank.branch = null;
      this.bank.account_number = null;
      this.bank.account_owner = null;
    },

    validateAddBank() {
      if (!this.bank.name) {
        this.$swal('Bank Name required', 'Please fill Bank name to continue', 'warning');
        return false;
      }
      if (!this.bank.account_number) {
        this.$swal('Account Number required', 'Please fill Account Number to continue', 'warning');
        return false;
      }
      if (!this.bank.account_owner) {
        this.$swal('Account Owner required', 'Please fill Account Owner to continue', 'warning');
        return false;
      }

      return true;
    },

    validate() {
      if (!this.merchant.name) {
        this.$swal('Agent Name required', 'Please fill Agent name to continue', 'warning');
        return false;
      }
      if (!this.merchant.address) {
        this.$swal('Address required', 'Please fill Address to continue', 'warning');
        return false;
      }
      if (!this.merchant.city) {
        this.$swal('City required', 'Please City to continue', 'warning');
        return false;
      }
      if (!this.merchant.province) {
        this.$swal('Province required', 'Please fill Province to continue', 'warning');
        return false;
      }
      if (!this.merchant.country) {
        this.$swal('Country required', 'Please fill Country to continue', 'warning');
        return false;
      }
      if (!this.merchant.zip_code) {
        this.$swal('Zip Code required', 'Please fill Zip Code to continue', 'warning');
        return false;
      }
      if (!this.merchant.phone) {
        this.$swal('Agent Phone Number required', 'Please fill Agent Phone Number to continue', 'warning');
        return false;
      }
      if (!this.merchant.email) {
        this.$swal('Agent Email required', 'Please fill Agent Email to continue', 'warning');
        return false;
      }
      if (!this.merchant.pic_name) {
        this.$swal('PIC Name required', 'Please fill PIC Name to continue', 'warning');
        return false;
      }
      if (!this.merchant.pic_phone) {
        this.$swal('PIC phone number required', 'Please fill PIC phone number to continue', 'warning');
        return false;
      }
      if (!this.merchant.pic_email) {
        this.$swal('PIC Email required', 'Please fill PIC Email to continue', 'warning');
        return false;
      }
      if (this.merchant.banks.length < 1) {
        this.$swal('Bank Account required', 'Please fill Bank Account to continue', 'warning');
        return false;
      }

      return true;
    },

    submit() {
      const result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },

    generateBank(data) {
      const banks = [];
      data.forEach((bank) => {
        banks.push({
          id: bank.id || null,
          merchant_id: this.$route.params.id || null,
          currency: bank.currency,
          swift_code: bank.swift_code,
          bank_name: bank.name,
          bank_branch: bank.branch,
          account_number: parseInt(bank.account_number, 10),
          account_owner: bank.account_owner,
        });
      });

      return JSON.stringify(banks);
    },

    generateData() {
      /* eslint-disable */
      const {
        id,
        name,
        address,
        city,
        province,
        country,
        zip_code,
        phone,
        email,
        pic_name,
        pic_phone,
        pic_email,
        banks,
      } = this.merchant;

      const data = {};

      data.id = id;
      data.name = name;
      data.address = address;
      data.city = city;
      data.province = province;
      data.country = country;
      data.zip_code = zip_code;
      data.phone = phone;
      data.email = email;
      data.pic = pic_name;
      data.contact_person = pic_phone;
      data.pic_email = pic_email;
      data.banks = this.generateBank(banks);

      return this.stringify(data);
    },

    create() {
      const data = this.generateData();

      this.axios.post('/merchants', data)
        .then(() => {
          bus.$emit('destroy-editor');
          this.$swal({
            title: 'Created',
            text: `Merchant ${this.merchant.name} has been created.`,
            type: 'success',
            timer: 3000,
          });

          this.$router.go(-1);
        })
        .catch((error) => {
          console.log('error', error);

          if (error.response) {
            this.errors = error.response.data.errors;
          }

          if (error) {
            const merchant = this.merchant.name || 'merchant';
            this.$swal({
              title: 'Create Failed!',
              text: `Failed to create ${merchant}`,
              type: 'warning',
              timer: 5000,
            });
          }
        });
    },

    update() {
      const data = this.generateData();

      this.axios.put(`/merchants/${this.merchant.id}`, data)
        .then(() => {
          bus.$emit('destroy-editor');
          this.$swal({
            title: 'Updated',
            text: `Merchant ${this.merchant.name} has been updated.`,
            type: 'success',
            timer: 3000,
          });

          this.$router.go(-1);
        })
        .catch((error) => {
          if (error.response) {
            this.errors = error.response.data.errors;
          }

          if (error) {
            this.$swal({
              title: 'Create Failed!',
              text: `Failed to update ${this.merchant.name}`,
              type: 'warning',
              timer: 5000,
            });
          }
        });
    },

    cancel() {
      bus.$emit('destroy-editor');
      this.$router.go(-1);
    },
  },

  created() {
    if (!this.isCreate) {
      this.fetch();
      this.title = 'Edit Merchant';
    }
  },
  destroyed() {
    bus.$off('close-modal');
  },
};
</script>

<style lang="scss" scoped>
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  .margin-header{
    margin-bottom:10px
  }
  .line-height{
    line-height: 34px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/merchant/Form.vue